import { gql } from "@apollo/client";

export const NOTIFICATIONS = gql`
subscription Subscription($userId: String!) {
  notification(userId: $userId) {
    userId
    title
    description
    subCategory
    category
    createdAt
    updatedAt
    type
    expiryTime
  }
}
`;

export const GET_ALL_NOTIFICATIONS = gql`
  query getAllNotifications {
    getAllNotifications{
      totalNotifications
      totalUnreadNotifications
      notifications{
        notificationMessageId
        userId
        title
        description
        type
        expiryTime
        category
        subCategory
        ctaName
        imageUrl
        ctaData {
          appointmentId
          petId
          petSpecies
          petName
          petBreed
        }
        status
        readAt
        createdAt
      }
      messages
      success
    }
}`;


